import { Card, CardContent, Typography, Box, Avatar, Divider } from '@mui/material';

const DashboardCard = ({ title, icon, color, hoverColor, children }) => (
    <Box sx={{ display: 'flex', width: '100%' }}>
        <Card
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#1f2937',
                borderRadius: '16px',
            }}
        >
            <CardContent sx={{ display: 'flex', flexDirection: 'column', flex: 1, p: { xs: 1.5, sm: 2 } }}>
                <Box display="flex" alignItems="center" mb={1.5}>
                    <Avatar sx={{ bgcolor: color, mr: 1, width: 32, height: 32 }}>{icon}</Avatar>
                    <Typography variant="subtitle2" fontWeight={600} color={hoverColor === '#3b82f6' ? '#e0f2fe' : '#ecfdf5'}>
                        {title}
                    </Typography>
                </Box>
                <Divider sx={{ mb: 1.5, borderColor: `rgba(${hoverColor.match(/\d+/g).join(', ')}, 0.2)` }} />
                {children}
            </CardContent>
        </Card>
    </Box>
);

export default DashboardCard;
